import React from 'react';
import PropTypes from 'prop-types';
import { postData } from './utils';
import Form from './Form';
import styles from './styles';

const CoolForm = ({ title }) => (
  <Form onSubmit={formData => postData(formData)} source={title}>
    {({ submitting }) => (
      <Form.Fetch url="https://gdpr-service.herokuapp.com/is-gdpr">
        {({ isGDPR, loading }) => (
          <div>
            <Form.Group>
              <Form.Input
                type="text"
                name="company"
                placeholder="Company Name"
                disabled={loading || submitting}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                type="text"
                name="website"
                placeholder="Website"
                disabled={loading || submitting}
                small
                left
              />
              <Form.Input
                type="text"
                name="contact"
                placeholder="Contact Name"
                disabled={loading || submitting}
                small
                right
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                type="email"
                name="email"
                placeholder="Email"
                disabled={loading || submitting}
                small
                left
                required
              />
              <Form.Input
                type="text"
                name="phone"
                placeholder="Phone"
                disabled={loading || submitting}
                small
                right
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                type="text"
                name="city"
                placeholder="City"
                disabled={loading || submitting}
                small
                left
              />
              <Form.Input
                type="text"
                name="country"
                placeholder="Country"
                disabled={loading || submitting}
                small
                right
              />
            </Form.Group>
            <Form.Group>
              <Form.TextArea
                name="msg"
                placeholder="Brief description of partner opportunity..."
                disabled={loading || submitting}
              />
            </Form.Group>
            {isGDPR && (
              <div style={styles.gdpr.wrapper}>
                <p>
                  We&apos;d also like to reach out when we have something worth sharing. You can
                  always change your mind and{' '}
                  <a href="https://auth0.com/preference-center">opt out at any time.</a>
                </p>
                <div>
                  <Form.ConsentRadioButton value="yes" id="consent-accepted">
                    Email me product updates, resources, surveys, offers, and event info.
                  </Form.ConsentRadioButton>
                  <Form.ConsentRadioButton value="no" id="consent-rejected">
                    No, thank you. I’ll just sign up.
                  </Form.ConsentRadioButton>
                </div>
              </div>
            )}
            <Form.Group>
              <Form.SubmitButton disabled={loading || submitting}>
                {submitting ? 'Sending...' : title}
              </Form.SubmitButton>
            </Form.Group>
          </div>
        )}
      </Form.Fetch>
    )}
  </Form>
);

CoolForm.propTypes = {
  title: PropTypes.string.isRequired
};

export default CoolForm;



// WEBPACK FOOTER //
// ./src/pages/partners/components/Form/index.js